"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var skillTreeApi_1 = require("../mock/skillTreeApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var skillTreeApi = {
    getUserSkillTree: function (skillTreeUuid, selectedLearningPathUuid, token) {
        return rest_1.default.get({
            mockFunc: function () { return skillTreeApi_1.mockUserSkillTree; },
            url: "".concat(coreServiceUrl, "/user-skill-tree/").concat(skillTreeUuid, "?").concat(selectedLearningPathUuid ? "selectedLearningPathUuid=".concat(selectedLearningPathUuid) : ''),
            token: token,
        });
    },
    getSkillTrees: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return skillTreeApi_1.mockSkillTrees; },
            url: "".concat(coreServiceUrl, "/skill-trees"),
            token: token,
        });
    },
};
exports.default = skillTreeApi;
